/**
 * 資本金規模カテゴリー
 */
export const CapitalSizeCode = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
} as const

export type CapitalSizeCodeValue =
  (typeof CapitalSizeCode)[keyof typeof CapitalSizeCode]

export const CapitalSizeLabel: { [key: string]: string } = {
  [CapitalSizeCode.SMALL]: '1,000万円未満',
  [CapitalSizeCode.MEDIUM]: '1,000万円-1億円',
  [CapitalSizeCode.LARGE]: '1億円以上',
}

export const CapitalSizeValues = Object.entries(CapitalSizeLabel).map(
  ([code, value]) => ({
    code,
    value,
  })
)
